import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuditLogTable } from '@/components/audit/AuditLogTable';
import { LogFilterBar } from '@/components/audit/LogFilterBar';
import { RequestLogTable } from '@/components/audit/RequestLogTable';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { LogFilters } from '@/types/auditLog';
import { PageHeader } from '@/components/PageHeader';

export function AuditLogsPage() {
  const [searchParams] = useSearchParams();
  const initialKey = searchParams.get('api_key_id');
  const initial: LogFilters = { page: 1, limit: 50, api_key_id: initialKey ? Number(initialKey) : undefined };

  const [tab, setTab] = useState(searchParams.get('tab') === 'requests' ? 'requests' : 'audit');
  const [auditFilters, setAuditFilters] = useState<LogFilters>(initial);
  const [requestFilters, setRequestFilters] = useState<LogFilters>(initial);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  return (
    <div className="space-y-6">
      <PageHeader
        title="Audit Logs"
        description="Who changed what, and every API request."
        actions={
          <Button onClick={() => setRefreshTrigger((n) => n + 1)} variant="outline">
            Refresh
          </Button>
        }
      />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="audit">Mutations</TabsTrigger>
          <TabsTrigger value="requests">All requests</TabsTrigger>
        </TabsList>
        <TabsContent value="audit">
          <Card>
            <CardHeader>
              <LogFilterBar mode="audit" filters={auditFilters} onChange={setAuditFilters} />
            </CardHeader>
            <CardContent>
              <AuditLogTable filters={auditFilters} onFiltersChange={setAuditFilters} refreshTrigger={refreshTrigger} />
            </CardContent>
          </Card>
        </TabsContent>
        <TabsContent value="requests">
          <Card>
            <CardHeader>
              <LogFilterBar mode="requests" filters={requestFilters} onChange={setRequestFilters} />
            </CardHeader>
            <CardContent>
              <RequestLogTable filters={requestFilters} onFiltersChange={setRequestFilters} refreshTrigger={refreshTrigger} />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
